import { number, object, string } from "yup";

export const TaxSettingsValidationSchema = object({
    personalTaxPercentage: number().required("Задолжително"),
    taxRelease: number().required("Задолжително"),
    taxReleaseForBonuses: number().required("Задолжително"),
    contributions: number().required("Задолжително"),
});
